import { DropdownLayout } from '../components';
import type { StyleProps } from './types';

export function Style10({ items, onClick }: StyleProps) {
  return (
    <DropdownLayout
      items={items}
      withFlag
      flagStyle="squared"
      activeItemNameKey="originalName"
      onClick={onClick}
    />
  );
}
